import { useMutation, useQuery, useQueryClient } from 'react-query';
import { getLoggedInUsername } from 'api/account';
import {
  createCompany,
  createOrganisation,
  getUserOrganisations,
  OrganisationTree,
} from 'api/organisations';
import { billingCompaniesQueryKey } from 'hooks/useBillingCompanies';

export const organisationsQueryKey = () =>
  ['organisations', 'user-all', getLoggedInUsername() ?? ''] as const;

export const useUserOrganisations = () =>
  useQuery(organisationsQueryKey(), getUserOrganisations, {
    staleTime: 30_000,
    retry: 1,
  });

export const useCreateOrganisation = () => {
  const queryClient = useQueryClient();
  return useMutation((name: string) => createOrganisation(name), {
    onSuccess: () => {
      queryClient.invalidateQueries(organisationsQueryKey());
      queryClient.invalidateQueries(billingCompaniesQueryKey());
    },
  });
};

export const useCreateCompany = () => {
  const queryClient = useQueryClient();
  return useMutation(createCompany, {
    onSuccess: () => {
      queryClient.invalidateQueries(organisationsQueryKey());
      queryClient.invalidateQueries(billingCompaniesQueryKey());
    },
  });
};

export type { OrganisationTree };
